import { useQuery } from "react-query"
import {getDashboard} from './dashboardService'
import {DASHBOARD} from '../constants'

const useGetDashboard  = () => {
  return useQuery(DASHBOARD, () => getDashboard())
}

export default useGetDashboard
